import React, { useState, useEffect } from "react";
import styles from "../BrokerCRM.module.css";

const questionsByStep = {
  property: {
    purchase: [
      "Are you purchasing your first property?",
      "Do you already have pre-approval, or is this an initial enquiry?",
      "How much deposit do you have saved and where is it held?",
      "Are you buying with someone else, or on your own?",
      "Have you factored in stamp duty, legal, and government costs?",
    ],
    refinance: [
      "What’s the main reason for refinance? (lower rate, cashback, debt consolidation, cash out)",
      "What’s your current interest rate and lender?",
      "Are you happy with your current loan features (offset, redraw, fixed/variable)?",
      "Would you like to access equity for renovations, investment, or other purposes?",
      "Do you want to consolidate other debts (credit cards, personal loans)?",
    ],
  },
  applicants: [
    "Who will be on the application?",
    "What are your current living arrangements?",
    "Do you have any dependants?",
    "What’s your current employment situation?",
    "Do you have a partner contributing to the loan?",
  ],
  income: [
    "What is your base salary?",
    "Do you earn additional income like overtime or commission?",
    "Do you have rental income?",
    "Any government payments or allowances?",
    "Any other sources of income?",
  ],
  assets: [
    "Do you own any vehicles?",
    "Do you have savings or term deposits?",
    "Do you own property already?",
    "Do you have shares or investments?",
    "Any superannuation balances to declare?",
  ],
  expenses: [
    "What are your monthly living costs?",
    "Do you pay school or childcare fees?",
    "Do you have any regular subscriptions or insurances?",
    "How much do you spend on transport monthly?",
    "Do you have board or rent payments?",
  ],
  objectives: [
    "What is your main goal for this loan?",
    "Do you want flexibility or the lowest possible rate?",
    "Would you prefer fixed, variable, or split?",
    "How long do you plan to hold the property?",
    "Do you want redraw/offset features?",
  ],
  capacity: [
    "Do you know how much you’re comfortable borrowing?",
    "Do you want to see scenarios with different deposit sizes?",
    "Do you want to compare lenders?",
    "Should we factor in future expenses (kids, school fees)?",
    "Would you like us to model repayments at higher interest rates?",
  ],
  review: [
    "Do you feel confident with the information provided?",
    "Is there anything you’d like clarified?",
    "Do you want us to prepare a borrowing summary?",
    "Are you ready to move forward with an application?",
    "Would you like us to set up a meeting with your broker?",
  ],
};

function SuggestedQuestions({ step, applicationType }) {
  const [typedText, setTypedText] = useState("");
  const [displayedQuestions, setDisplayedQuestions] = useState([]);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [questions, setQuestions] = useState([]);

  // Load correct questions when step/applicationType changes
  useEffect(() => {
    let q = [];

    if (step === "property" && applicationType) {
      q = questionsByStep.property[applicationType.toLowerCase()] || [];
    } else if (step && step !== "property") {
      q = questionsByStep[step] || [];
    }

    setQuestions(q);
    setDisplayedQuestions([]);
    setTypedText("");
    setQuestionIndex(0);
    setCharIndex(0);
  }, [step, applicationType]);

  // Typewriter effect
  useEffect(() => {
    if (questions.length === 0) return;

    if (questionIndex < questions.length) {
      if (charIndex < questions[questionIndex].length) {
        const timeout = setTimeout(() => {
          setTypedText((prev) => prev + questions[questionIndex][charIndex]);
          setCharIndex((prev) => prev + 1);
        }, 50);
        return () => clearTimeout(timeout);
      } else {
        // Finish one question
        setDisplayedQuestions((prev) => [...prev, questions[questionIndex]]);
        setTypedText("");
        setCharIndex(0);
        setQuestionIndex((prev) => prev + 1);
      }
    }
  }, [charIndex, questionIndex, questions]);

  return (
    <div className={styles.suggestedQuestions}>
      <h4>💡 Suggested Questions</h4>
      {questions.length > 0 ? (
        <ul>
          {displayedQuestions.map((q, i) => (
            <li key={i}>{q}</li>
          ))}
          {typedText && <li>{typedText}<span className={styles.cursor}>|</span></li>}
        </ul>
      ) : (
        <p>Select an Application Type to see suggested questions.</p>
      )}
    </div>
  );
}

export default SuggestedQuestions;
